import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
import dayjs from "dayjs";
import {
  useFormattedUserListOption,
  useFormattedVehicleCategoryOption,
  useFormattedVehicleTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import PropTypes from "prop-types";
import InputWarningMessage from "Components/UI/InputWarningMessage";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const projectStatusOptions = [
  { label: "Pending", value: "Pending" },
  { label: "Processing", value: "Processing" },
  { label: "Completed", value: "Completed" },
];

const ClientInformation = ({ userData }) => {
  const {
    watch,
    setValue,
    trigger,
    register,
    formState: { errors },
  } = useFormContext();

  const approvedByOptions = useFormattedUserListOption({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });
  // console.log("approvedByOptions", approvedByOptions);
  const index = 0;
  return (
    <>
      <div className="form-row row">
        <h4 className="header-title">Client Information</h4>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`clientDetails.clientCompany`}
            type="text"
            placeholder="Client Company"
            className={`form-control ${
              errors?.clientDetails?.clientCompany
                ? "is-invalid"
                : ""
            }`}
            label="Client Company"
            labelClassName="form-label"
            required={false}
            requiredMessage="Client Company is required"
            defaultValue=""
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`clientDetails.mainContact`}
            type="text"
            placeholder="Main Contact"
            className={`form-control ${
              errors?.clientDetails?.mainContact
                ? "is-invalid"
                : ""
            }`}
            label="Main Contact"
            labelClassName="form-label"
            required={false}
            requiredMessage="Main Contact is required"
            pattern="\d*"

            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`clientDetails.contact2`}
            type="text"
            placeholder="Contact 2"
            className={`form-control ${
              errors?.clientDetails?.contact2 ? "is-invalid" : ""
            }`}
            label="Contact 2"
            labelClassName="form-label"
            required={false}
            requiredMessage="Contact 2 is required"
            // dateFormat="DD-MM-YYYY"
            pattern="\d*"

          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`clientDetails.remarks`}
            type="text"
            placeholder="Remarks"
            className={`form-control ${
              errors?.clientDetails?.remarks ? "is-invalid" : ""
            }`}
            label="Remarks"
            labelClassName="form-label"
            required={false}
            requiredMessage="Remarks is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`clientDetails.address`}
            type="text"
            placeholder="Address"
            className={`form-control select ${
              errors?.clientDetails?.address ? "is-invalid" : ""
            }`}
            label="Address"
            labelClassName="form-label"
            required={false}
            requiredMessage="Address is required"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`clientDetails.email`}
            type="text"
            placeholder="Email"
            className={`form-control select ${
              errors?.clientDetails?.email ? "is-invalid" : ""
            }`}
            label="Email"
            labelClassName="form-label"
            required={false}
            requiredMessage="Email is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
          <Input
            name={`clientDetails.email2`}
            type="text"
            placeholder="Email 2"
            className={`form-control select ${
              errors?.clientDetails?.email ? "is-invalid" : ""
            }`}
            label="Email 2"
            labelClassName="form-label"
            required={false}
            requiredMessage="Email 2 is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`clientDetails.isActive`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.clientDetails?.isActive ? "is-invalid" : ""
            }`}
            label="Active Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={false}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue(
                `clientDetails.isActive`,
                selectedOption?.value
              );
              trigger(`clientDetails.isActive`);
            }}
            defaultValue={watch(`clientDetails.isActive`)}
          />
        </div>
      </div>
      <InputWarningMessage
        message="*All mandatory fields to be entered to Save the record."
        type="danger"
      />
    </>
  );
};
ClientInformation.propTypes = {
  userData: PropTypes.any.isRequired,
};
export default React.memo(ClientInformation);
